var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionHide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-445.000000, -1448.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-and-action/Hide",
    transform: "translate(445.000000, 1448.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9819623,5.42150165 C30.4749857,8.24255455 32,11.9396239 32,15.9997 C32,24.8368657 24.8359328,32 15.99985,32 C11.9398119,32 8.24277728,30.4749714 5.42175083,27.9829247 L5.42175083,27.9829247 L12.8488205,20.5547854 C13.8538299,20.8477909 14.8908396,20.9997937 15.9908499,20.9997937 C19.5128829,20.9997937 22.39691,19.5787671 25.5019391,15.9997 C24.0239252,14.295668 22.5949118,13.0836453 21.123898,12.2796302 L21.123898,12.2796302 Z M16.00015,3.55271368e-15 C20.055188,3.55271368e-15 23.7472226,1.52102852 26.5672491,4.00807515 L26.5672491,4.00807515 L16.4531542,14.1222648 C16.316153,14.0502634 16.1661516,14.0002625 15.99915,14.0002625 C15.4481448,14.0002625 14.9991406,14.4472709 14.9991406,15.0002813 C14.9991406,15.1662844 15.0501411,15.3152872 15.1221418,15.4532897 L15.1221418,15.4532897 L12.2731151,18.3023432 C11.4901077,17.4193266 11.0011031,16.2723051 11.0011031,15.0002813 C11.0011031,13.6762564 11.525108,12.481234 12.3641159,11.5862172 C10.3380969,12.2922305 8.44707919,13.6772564 6.50206096,16.0003 C7.95307456,17.7313325 9.37508789,18.933355 10.8441017,19.73137 L10.8441017,19.73137 L4.00803758,26.5674981 C1.52101426,23.7474453 3.55271368e-15,20.055376 3.55271368e-15,16.0003 C3.55271368e-15,7.16313431 7.16406716,3.55271368e-15 16.00015,3.55271368e-15 Z M20.5063922,12.8967418 C20.8113951,13.5377538 20.9983969,14.2427671 20.9983969,14.9997812 C20.9983969,17.760833 18.7603759,19.999875 15.99935,19.999875 C15.2413429,19.999875 14.5313362,19.8178716 13.8873302,19.5168659 L13.8873302,19.5168659 Z",
    id: 180
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionHide);
export default __webpack_public_path__ + "static/media/navigation-and-action-hide.fe985c19.svg";
export { ForwardRef as ReactComponent };